// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import Vuex from 'vuex'
import axios from "axios";
import base from './api/base';
import iView from 'iview';
// import Swiper from 'swiper';
import "./assets/css/reset.css";
import 'swiper/dist/css/swiper.css';
import 'mint-ui/lib/style.css';
import 'iview/dist/styles/iview.css'

Vue.config.productionTip = false
Vue.use(MintUI);
Vue.use(Vuex);
Vue.use(base);
Vue.use(iView);
// Vue.use(Swiper);

function setHtmlFontSize(){
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = htmlWidth /7.5 + 'px';
};
setHtmlFontSize();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created(){
    router.afterEach((to,from,next) => {
      var scroll = document.documentElement.scrollTop||document.body.scrollTop
      console.log(scroll)
      if(scroll>0){
        window.scrollTo(0,0);
      }
    })

  },
  computed:{
    

  }
})



// WEBPACK FOOTER //
// ./src/main.js